// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r-maxHeight-19uj1o {
  max-height: "auto";
}

.custom-modal {
  padding-top: 400px;
}
/* 
.r-right-zchlnj {
  right: -10px;
}

.r-left-1d2f490 {
  left: -11px;
} */

.modal-open {
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/components/modal/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;;;;;;;GAOG;;AAEH;EACE,2BAA2B;AAC7B","sourcesContent":[".r-maxHeight-19uj1o {\n  max-height: \"auto\";\n}\n\n.custom-modal {\n  padding-top: 400px;\n}\n/* \n.r-right-zchlnj {\n  right: -10px;\n}\n\n.r-left-1d2f490 {\n  left: -11px;\n} */\n\n.modal-open {\n  overflow: hidden !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
